import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.loftControl || initialState;

export const selectLoftControl = createSelector([selectSlice], state => state);

export const selectLoftControlReport = createSelector(
  [selectSlice],
  state => state,
);
